import { useState, useEffect } from 'react';
import { getConditionMonitoringQuestions } from 'services/analytics';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { showError } from '../../../../../redux/common/actions';
import { SHOW_ALL_OPTION } from '../../constants';

export const useQuestions = (modelVersionId, modelVersionRoleId, modelVersionIntervalId, showAll = true) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [questions, setQuestions] = useState([]);

  useEffect(() => {
    const loadQuestions = async () => {
      // Reset questions to empty if modelVersionId is missing
      if (!modelVersionId) {
        setQuestions([]);
        return;
      }
      
      try {
        const response = await getConditionMonitoringQuestions({
          modelVersionId,
          modelVersionRoleId: modelVersionRoleId || '',
          modelVersionIntervalId: modelVersionIntervalId || ''
        });
        
        let updatedQuestions = []; // Default to empty
        if (response?.status) {
          const fetchedQuestions = response.data || [];
          
          // Generate unique IDs for each question
          const processedQuestions = fetchedQuestions.map(q => ({
            ...q,
            // Create a unique ID by combining the relevant fields
            id: `${q.modelVersionStageID || ''}-${q.modelVersionTaskQuestionID || ''}-${q.modelVersionZoneID || ''}-${q.modelVersionTaskID || ''}`
          }));
          
          // Only add "Show All" option if explicitly configured to do so
          updatedQuestions = (showAll && processedQuestions.length > 0)
            ? [SHOW_ALL_OPTION, ...processedQuestions]
            : processedQuestions;
        }
        setQuestions(updatedQuestions);
      } catch (error) {
        dispatch(showError(t('message.failedToLoadQuestions')));
        setQuestions([]); // Reset on error
      }
    };
    loadQuestions();
  }, [modelVersionId, modelVersionRoleId, modelVersionIntervalId, showAll, t]);

  return questions;
}; 
